import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { About } from '@/components/sections/About';
import { Services } from '@/components/sections/Services';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        <meta name="robots" content="max-image-preview:large" />
        <link rel="canonical" href="https://borderair.com/" />
        <meta name="theme-color" content="#212121" />
        
        {/* Open Graph Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={siteData.ogTitle || siteData.title} />
        <meta property="og:description" content={siteData.ogDescription || siteData.description} />
        <meta property="og:url" content="https://borderair.com/" />
        <meta property="og:locale" content="en_US" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content={siteData.twitterTitle || siteData.title} />
        
        {/* Fonts */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link 
          href="https://fonts.googleapis.com/css2?family=Karla:wght@400&family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&display=swap" 
          rel="stylesheet" 
        />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <About />
          <Services />
        </main>
        <Footer />
      </div>
    </>
  );
}